var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{key:_vm.$store.state.ThemesStore.currentTheme,attrs:{"background":_vm.$vuetify.theme.currentTheme.secondary}},[_c('router-view'),_c('SnackbarHandler')],1)}
var staticRenderFns = []

export { render, staticRenderFns }